import { render, staticRenderFns } from "./set-top-audio.vue?vue&type=template&id=c9bb4a90&scoped=true&"
import script from "./set-top-audio.vue?vue&type=script&lang=ts&"
export * from "./set-top-audio.vue?vue&type=script&lang=ts&"
import style0 from "./set-top-audio.vue?vue&type=style&index=0&id=c9bb4a90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9bb4a90",
  null
  
)

export default component.exports